import {Answer} from 'Models'


export const meetsThreshold = (correctCount, allCount) =>
    (allCount*Answer.getThresholdForSuccess()) <= (correctCount*100)
